module.exports = __webpack_public_path__ + "img/main.d4d7df3d.png";